/** The anchor of the spans card on the reservation page: a link with this hash scrolls to it. */
export const RESERVATION_SPANS_ANCHOR = 'spans' as const;
